import React, { lazy } from 'react';

const Services = lazy(() => import('./Services'));

export { Services }